import { render, staticRenderFns } from "./dangerJournalDetail.vue?vue&type=template&id=332b6064"
import script from "./dangerJournalDetail.vue?vue&type=script&lang=js"
export * from "./dangerJournalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332b6064')) {
      api.createRecord('332b6064', component.options)
    } else {
      api.reload('332b6064', component.options)
    }
    module.hot.accept("./dangerJournalDetail.vue?vue&type=template&id=332b6064", function () {
      api.rerender('332b6064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerJournalDetail.vue"
export default component.exports